<mat-card>
    <mat-card-title>Recipient Option</mat-card-title>

    <mat-tab-group
        [selectedIndex]="selectedTabIndex"
        (selectedTabChange)="onTabChange($event)"
        [disablePagination]="true"
    >
        <mat-tab label="This is for me">
            <span>
                You will receive the gift card by email. You can also choose to
                print it after checkout.
            </span>
        </mat-tab>
        <mat-tab label="This is for someone else">
            <div class="recipient-option-inputs" (keyup.enter)="submitForm()">
                <div class="form-field">
                    <mat-form-field>
                        <input
                            matInput
                            maxlength="50"
                            placeholder="Recipient Name"
                            formControlName="recipientName"
                        />
                        <mat-error *ngIf="recipientName.errors?.required">
                            Recipient name is required</mat-error
                        >
                    </mat-form-field>
                </div>

                <div class="form-field">
                    <mat-form-field>
                        <input
                            matInput
                            maxlength="60"
                            placeholder="Recipient Email"
                            formControlName="recipientEmail"
                        />
                        <mat-error *ngIf="recipientEmail.errors?.required">
                            Recipient email is required</mat-error
                        >
                        <mat-error *ngIf="!recipientEmail.errors?.required">
                            Recipient email is invalid</mat-error
                        >
                    </mat-form-field>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
</mat-card>
